import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";
import { baseValues } from "../assets/script/bases.js";
import { frameworkActions } from "../state/FrameworkReducer.js";
import { DispatchAction } from "../state/State.js";
import { uiActions } from "../state/UiReducer.js";
import { aspectColors, PlayerKey } from "../assets/script/constants";

/**
 * @name SelectBaseModal
 * @class SelectBaseModal
 * @extends {ConnectedHTMLElement}
 * @description
 *
 */
export class SelectBaseModal extends ConnectedHTMLElement {
  constructor() {
    super();
  }

  baseElementList() {
    const baseArr = baseValues.map((base) => {
      return `<li class="flex flex-row min-h-1">
        <span style="background-color: ${aspectColors[base.aspect]}" class="inline-block mr-2 w-[20px]">&nbsp;</span>
        <button 
          class="pointer border-b flex flex-row justify-between w-full px-2 py-4 " 
          data-base="${base.programmaticName}">
            <span>${base.name}</span><span>${base.hp}hp</span>
          </button>
        </li>`;
    });

    return baseArr.join("");
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    // Should open modal
    const modal = this.querySelector("#select-modal");
    const player = this.state.ui.showBaseModal.player;
    if (newState.ui.showBaseModal.show && !oldState.ui.showBaseModal.show) {
      if (player === PlayerKey.top) {
        modal.classList.add("rotate-180");
      } else {
        modal.classList.remove("rotate-180");
      }
      modal.showModal();
      return;
    }

    // Should close modal
    if (!newState.ui.showBaseModal.show && oldState.ui.showBaseModal.show) {
      modal.close();
    }
  }

  registerElementEvents() {
    const modal = this.querySelector("#select-modal");
    const baseItems = this.querySelectorAll("#base-list button");
    const closeBtn = this.querySelector("#close");

    closeBtn.addEventListener("click", () => {
      const player = this.state.ui.showBaseModal.player;
      DispatchAction(uiActions.toggleSelectBase, { show: false, player });
    });

    baseItems.forEach((button) => {
      button.addEventListener("click", (event) => {
        const player = this.state.ui.showBaseModal.player;
        const selectedBase = baseValues.find(
          (b) => b.programmaticName === button.dataset.base
        );
        console.log("🦕: ", player, selectedBase);
        DispatchAction(frameworkActions.setBase, {
          base: selectedBase,
          player,
        });
        DispatchAction(uiActions.toggleSelectBase, { show: false, player });

        modal.close();
      });
    });
  }

  render() {
    this.innerHTML = `
        <dialog class="modal z-50" id="select-modal">
          <div class="modal-box">
            <h3 class="font-bold text-2xl mb-2">Select your base!</h3>
            <ul id="base-list">
              ${this.baseElementList()}
            </ul>
            <div class="modal-action">
                <button id="close" class="btn w-full mt-2">Close</button>
            </div>
          </div>
        </dialog>
        `;
  }

  connectedCallback() {
    this.render();
    this.registerElementEvents();
  }

  dispatchEvent(event) {
    return false;
  }
}
